<div class="isg-full-page-header">
  <div class="isg-page-header">
    <div class="header-title">
      {{ _caption }}
    </div>
    <div class="header-search">
      <query-panel-filter-box #filterBox
                              class="indent"
                              (onFilterChange)="onFilterChange($event)"
                              placeholder="Search list..."
                              [showSearchButton]="true">
      </query-panel-filter-box>
    </div>
    <div class="header-right">
      <ng-container [ngTemplateOutlet]="toolbarTemplate">
      </ng-container>
      <button *ngIf="showHeaderOpenCloseButton"
              kendoButton
              class="button"
              (selectedChange)="onFilterShowHide($event)"
              [style.width.px]="36"
              [style.height.px]="36"
              [svgIcon]="filterSvg"
              title="Show / hide filter pane"
              [toggleable]="true"
              type="button"></button>
      <button *ngIf="showHeaderSearchButton"
              kendoButton
              class="button"
              (click)="onSearchRequest()"
              [svgIcon]="searchSvg"
              [title]="searchCaption"
              type="button"></button>
      <button *ngIf="showHeaderExcelButton"
              kendoButton
              class="button excelButton"
              (click)="onExportRequest()"
              [style.width.px]="36"
              [style.height.px]="36"
              [svgIcon]="excelSvg"
              title="Export to Excel"
              type="button"></button>
    </div>
  </div>
  <div class="isg-page-body">
    <div [class]="gridClass">
      <div #leftPane class="left" [style.max-width.px]="gridWidth">
        <ng-container [ngTemplateOutlet]="contentTemplate">
        </ng-container>
      </div>
      <div #rightPane class="right"
           [style.height.px]="paneHeight"
           [style.max-height.px]="paneHeight"
           [style.min-height.px]="paneHeight">
        <div class="k-loading-panel" *ngIf="loading">
          <div class="k-loading-panel-mask"></div>
          <div class="k-loading-panel-wrapper">
            <kendo-loader #loader
                          type="infinite-spinner"
                          themeColor="secondary"
                          size="medium">
            </kendo-loader>
            <div class="k-loading-panel-text">Loading...</div>
          </div>
        </div>
        <div class="buttons bottomMargin"
             *ngIf="showCriteriaSummary">
          <button kendoButton
                  class="button searchButtonIcon"
                  (click)="onSearchRequest()"
                  [svgIcon]="filterSvg"
                  title="Filter the results using these criteria"
                  type="button">
            {{searchCaption}}
          </button>
          <button kendoButton
                  class="button clearButton"
                  (click)="onClearClick()"
                  [svgIcon]="xCircleSvg"
                  title="Clear criteria"
                  type="button">
            Clear
          </button>
        </div>
        <criteria-summary-box #filterOutput
                              *ngIf="showCriteriaSummary"
                              class="bottomMargin">
        </criteria-summary-box>
        <div class="rightpanel">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
